import styled from 'styled-components';

export const Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    /* 데스크탑: 적당한 높이로 고정, 모바일: 전체화면을 채움 */
    height: 70vh;
    max-height: 680px;

    &.mobile {
        /* 모바일 전체화면: 부모 높이 체인에 의존하지 않고 뷰포트를 직접 채움 (브라우저 툴바 대응 dvh) */
        height: 100vh;
        height: 100dvh;
        max-height: none;
    }
`;

export const HeaderBar = styled.div`
    flex-shrink: 0;
    border-bottom: 1px solid #edf2f7;
`;

export const SearchBox = styled.div`
    flex-shrink: 0;
    padding: 12px 16px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    background: #fff;

    .inputWrap {
        position: relative;
        display: flex;
        align-items: center;
    }

    input {
        width: 100%;
        height: 48px;
        padding: 0 44px 0 14px;
        border: 1px solid #cbd5e0;
        border-radius: 10px;
        /* 16px 미만이면 iOS에서 포커스 시 화면 확대됨 → 16px 고정 */
        font-size: 16px;
        box-sizing: border-box;
        background: #f7fafc;

        &:focus {
            outline: none;
            border-color: var(--blueColor1, #2563eb);
            background: #fff;
        }
    }

    .clearButton {
        position: absolute;
        right: 6px;
        top: 50%;
        transform: translateY(-50%);
        width: 34px;
        height: 34px;
        border: none;
        background: #e2e8f0;
        color: #4a5568;
        border-radius: 50%;
        font-size: 13px;
        line-height: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }

    .resultMeta {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 12px;
        color: #718096;
        padding: 0 2px;

        .addedCount {
            color: var(--blueColor1, #2563eb);
            font-weight: 700;
        }

        .selectAll {
            display: flex;
            align-items: center;
            gap: 6px;
            font-weight: 600;
            color: #334155;
            cursor: pointer;
            user-select: none;

            input { width: 18px; height: 18px; }
        }
    }
`;

export const ListWrapper = styled.div`
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    background: #fff;
    border-top: 1px solid #edf2f7;
    display: flex;
    flex-direction: column;
`;

export const EmptyBox = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #a0aec0;
    font-size: 14px;
    padding: 40px 0;
`;

export const ListItem = styled.button`
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    /* 손가락 터치 타깃 확보 */
    min-height: 64px;
    padding: 12px 16px;
    border: none;
    border-bottom: 1px solid #edf2f7;
    background: #fff;
    text-align: left;
    cursor: pointer;
    transition: background-color 0.15s;

    &:active {
        background-color: #e6efff;
    }

    @media (hover: hover) {
        &:hover {
            background-color: #f1f5fb;
        }
    }

    &.justAdded {
        background-color: #eafaf0;
    }

    &.selected {
        background-color: #eaf1ff;
    }

    .checkbox {
        flex-shrink: 0;
        width: 24px;
        height: 24px;
        border: 2px solid #cbd5e0;
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-size: 14px;
        line-height: 1;
    }

    &.selected .checkbox {
        background: var(--blueColor1, #2563eb);
        border-color: var(--blueColor1, #2563eb);
    }

    .info {
        flex: 1;
        min-width: 0;
        display: flex;
        flex-direction: column;
        gap: 4px;
    }

    .productName {
        font-size: 15px;
        font-weight: 700;
        color: #1a202c;
        line-height: 1.3;
        /* 길면 2줄까지 보여주고 말줄임 */
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }

    .subLine {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 6px;
    }

    .optionName {
        font-size: 13px;
        color: #4a5568;
        word-break: break-all;
    }

    .optionCode {
        font-size: 11px;
        color: #2b6cb0;
        background: #ebf4ff;
        padding: 2px 8px;
        border-radius: 6px;
        font-weight: 600;
        white-space: nowrap;
    }

    .action {
        flex-shrink: 0;
        min-width: 52px;
        height: 36px;
        padding: 0 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 13px;
        font-weight: 700;
        color: var(--blueColor1, #2563eb);
        border: 1px solid var(--blueColor1, #2563eb);
        border-radius: 8px;
    }

    &.justAdded .action {
        color: #2f855a;
        border-color: #2f855a;
    }
`;

export const Footer = styled.div`
    flex-shrink: 0;
    padding: 12px 16px;
    /* iOS 홈 인디케이터 안전영역 */
    padding-bottom: calc(12px + env(safe-area-inset-bottom, 0px));
    border-top: 1px solid #e2e8f0;
    background: #fff;

    .closeButton {
        width: 100%;
        height: 52px;
        border: none;
        border-radius: 10px;
        background: var(--blueColor1, #2563eb);
        color: #fff;
        font-size: 15px;
        font-weight: 700;
    }
`;
